import get from 'lodash/get'
import isNil from 'lodash/isNil'

export default function (location) {
  let textFieldValue = ''
  let address = get(location, 'geojson.features[0].properties.label', null)
  if (!isNil(address)) {
    address = address.replace(', Australia', '')
    textFieldValue = address
  } else {
    const coords = get(location, 'coords', [])
    if (coords.length > 0) {
      let lng = get(coords, '[0]', '')
      let lat = get(coords, '[1]', '')
      if (lng !== '' && lat !== '') {
        lng = Math.round(lng * 1000000) / 1000000
        lat = Math.round(lat * 1000000) / 1000000
        textFieldValue = lng + ',' + lat
      }
    }
  }
  return textFieldValue
}
